export default __webpack_public_path__ + "static/media/123-british-columbia.15dc19ef.svg";